import React, { Component } from 'react';
import './StreamPlayer.css';
import PropTypes from "prop-types";
import Player from '@vimeo/player';

class StreamPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            playerInstance: {},
            playerId: 'showtix-stream-container',
            vimeoOptions: {
                //id: new URLSearchParams(window.location.search).get('vimeoid') || this.props.streamConfig.vimeo_video_id, // get real id
                id: this.props.videoType !== 'video-on-demand' ? `https://player.vimeo.com/video/${this.props.streamConfig.vimeo_video_id}?h=${this.props.streamConfig.vimeo_video_hash}` : new URLSearchParams(window.location.search).get('vimeoid') || this.props.streamConfig.vimeo_video_id,
                //hash: new URLSearchParams(window.location.search).get('vimeohash') || this.props.streamConfig.vimeo_video_hash, // get real id
                width: '100%',
                height: '100%',
                autoplay: true,
                playsinline: true,
                muted: false,
                texttrack: 'en',
                color: '#5c649b'
            }
        };
    }

    componentDidMount() {
        this.initVideoPlayer();
    }

    initVideoPlayer = () => {
        const playerInstance = new Player(this.state.playerId, this.state.vimeoOptions);

        this.setState({
            playerInstance
        });
    };

    render() {
        return (
            <React.Fragment>
                <div className="showtix-stream-container" id="showtix-stream-container"></div>
            </React.Fragment>
        );
    }
}

StreamPlayer.propTypes = {
    activationCode: PropTypes.string,
    videoType: PropTypes.string,
    streamConfig: PropTypes.object
};

export default StreamPlayer;


// WEBPACK FOOTER //
// ./src/components/Stream/StreamPlayer/StreamPlayer.js